'use strict';
var React = require('react');
var reactDom = require('react-dom');
var ReactRedux = require('react-redux');
var Store = require('../../redux/store.js');
//var LogBox = require('react-native');

// Ignore log notification by message
//LogBox.ignoreLogs(['Warning: ...']);

//Ignore all log notifications
//LogBox.ignoreAllLogs();

if (window.APP === 'user-cart') {
    let CartPageComponent = require('../../views/cart/main').CartPage;
    const store = Store.createCartStore(window.REDUX_DATA);

    const app = document.getElementById("root");
    reactDom.render(
        <ReactRedux.Provider store={store} suppressHydrationWarning={true}>
            <CartPageComponent suppressHydrationWarning={true}/>
        </ReactRedux.Provider>,
        app);
}